/* Saved and application rows are photo batches too, including after See all. */
window.CollabSeason.ready.then(()=>{
  const C=window.CollabSeason;
  for(const id of ['appsList','savedList']){
    const list=document.getElementById(id);if(!list)continue;
    let page=0;
    const nav=document.createElement('nav');nav.className='photo-pagination';nav.hidden=true;
    nav.setAttribute('aria-label',document.getElementById('dashH').textContent);
    const previous=document.createElement('button'),next=document.createElement('button'),count=document.createElement('span');
    for(const button of [previous,next]){button.type='button';button.className='btn';}
    previous.textContent=C.text('sa57b08a480b8');next.textContent=C.text('s1ff57a29d7c9');count.className='mono';count.setAttribute('aria-live','polite');
    nav.append(previous,count,next);list.after(nav);
    const render=()=>{
      const rows=[...list.children].filter(row=>row.querySelector('img')),size=C.photoCatalog.hub_page_size,pages=Math.max(1,Math.ceil(rows.length/size));
      page=Math.max(0,Math.min(page,pages-1));const selected=rows.slice(page*size,(page+1)*size);
      const deals=selected.map(row=>C.deals.find(d=>row.querySelector('a[href]')?.getAttribute('href')===d.url)).filter(Boolean);
      const photos=new Map(C.distinctPhotos(deals,C.photoCatalog.hub_reserved).map(d=>[d.id,d]));
      for(const row of rows){const on=selected.includes(row);row.hidden=!on;row.style.display=on?'':'none';if(on){const d=deals.find(d=>row.querySelector('a[href]')?.getAttribute('href')===d.url),photo=photos.get(d?.id);if(photo)row.querySelector('img').src=photo.cut;}}
      nav.hidden=rows.length<=size;previous.disabled=page===0;next.disabled=page===pages-1;count.textContent=(page+1)+' / '+pages;
    };
    previous.addEventListener('click',()=>{page--;render();});next.addEventListener('click',()=>{page++;render();});
    new MutationObserver(()=>{page=0;render();}).observe(list,{childList:true});render();
  }
});
